<template>
  <div class="subMenu">
    <div v-if="option?.type === 'color' || option?.type === 'font'" class="colorFilter">
      <div class="colorFilter__label">{{ option.children.label }}</div>
      <div class="colorFilter__colors">
        <div
          v-for="(item, index) in option.children.options"
          :key="index"
          class="colorFilter__color"
          :style="{
            backgroundColor: index === subIndex ? applyAlpha(item.bgColor, 0.5) : item.bgColor,
          }"
          @click="selectSubItem(item, $event)"
          @mouseenter="subIndex = index"
          @mouseleave="subIndex = null"
        ></div>
      </div>
      <div class="colorFilter__fill">No Fill</div>
    </div>
  </div>
</template>

<script>
import { HotkeyScopes } from "../../../utils/constants";
import hotkeys from "hotkeys-js";

export default {
  props: ["option"],
  data() {
    return {
      keyPressed: null,
      previousScope: null,
      subIndex: -1,
    };
  },

  mounted() {
    this.bindScope();
  },
  beforeUnmount() {
    this.unbindScope();
  },
  methods: {
    applyAlpha(color, alpha) {
      if (color.startsWith("#")) {
        // Convert hex to rgba
        const bigint = parseInt(color.slice(1), 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
      }
      // If already rgba() or something else, just return original
      return color;
    },

    bindScope() {
      this.previousScope = hotkeys.getScope();
      this.$store.dispatch("setScope", HotkeyScopes.FilterSubMenu);
      hotkeys("tab,shift+tab,right,left", HotkeyScopes.FilterSubMenu, (event, handler) => {
        event.preventDefault();
        const key = handler.key;
        if (key === "tab" || key === "right") {
          this.handleTab("forward");
        } else if (key === "shift+tab" || key === "left") {
          this.handleTab("backward");
        }
      });

      hotkeys("up,down", HotkeyScopes.FilterSubMenu, (event) => {
        event.preventDefault();
      });

      hotkeys("enter", HotkeyScopes.FilterSubMenu, (event) => {
        this.selectSubItem(this.option, event);
      });

      hotkeys("escape", HotkeyScopes.FilterSubMenu, (event) => {
        event.preventDefault();
        this.closeSubMenu();
      });

      hotkeys("*", HotkeyScopes.FilterSubMenu, (event) => {
        event.preventDefault();
      });
    },
    unbindScope() {
      this.$store.dispatch("setScope", this.previousScope);
      hotkeys.unbind("*,tab,shift+tab,enter,escape,left,right,up,down", HotkeyScopes.FilterSubMenu);
    },
    selectSubItem(item, event) {
      event.preventDefault();
      this.$emit("setSubItem", item);
    },
    closeSubMenu() {
      this.$emit("close");
      this.subIndex = -1;
    },
    handleTab(direction = "forward") {
      if (!this.option || !this.option.children) return;

      const total = this.option.children.options.length;

      if (direction === "forward") {
        this.subIndex = (this.subIndex + 1) % total;
      } else {
        this.subIndex = (this.subIndex - 1 + total) % total;
      }
    },
  },
};
</script>

<style lang="less">
@import "../../../assets/styles/variables.less";

.colorFilteShadow {
  box-shadow: 0px 4px 4px rgba(8, 50, 119, 0.2);
  border-radius: 4px;
}

.subMenu {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  padding: 10px 24px;
  border-radius: 4px;
  box-shadow: 0px 4px 4px rgba(8, 50, 119, 0.2);
  background: @kk-color-white;
}

.colorFilter,
.colorFilterDefault {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.colorFilterDefault {
  padding: 10px 20px;
  &__icon {
    font-size: 1.3rem;
    transition: transform 0.3s ease;
    transform: rotate(-90deg);
    cursor: pointer;
    margin-left: auto;

    &:hover {
      transform: rotate(0deg); /* rotated to 0 when active */
    }
    &.rotateDown {
      transform: rotate(-180deg); /* rotated to 0 when active */
    }
  }
}

.colorFilter {
  min-height: 120px;

  &__colors {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
  }

  &__color {
    width: 29px;
    height: 29px;
    border-radius: 2px;
    cursor: pointer;

    &--icon {
      font-size: 1.3rem;
      transition: transform 0.3s ease;
      transform: rotate(-90deg);
      cursor: pointer;
      &.rotateDown {
        transform: rotate(0deg); /* rotated to 0 when active */
      }
    }
  }

  &__fill {
    color: #c0c0c0;
    margin-top: auto;
    border-radius: 2px;
    padding-left: 4px;
    margin-top: 2rem;

    &:hover {
      color: @kk-color-primary-blue;
      background-color: @kk-sky-blue;
    }
  }
}
</style>
